import { useLobbyStore, useChatStore, useAppStore } from '@stores';
import { toast } from 'react-toastify';
import * as Shared from '@shared/lib';
import i18next from 'i18next';

export function initGlobalRegistry() {
  /* Lobby */

  Shared.MessageRegistry.emitter.on(Shared.LobbyLeftMessage.Opcode, (data) => {
    if (data.id === useAppStore.getState().id) return;
    toast(i18next.t('Lobby.left', { username: data.username }));
  });

  Shared.MessageRegistry.emitter.on(Shared.LobbyStatusMessage.Opcode, (data) => {
    if (data.gameId) {
      useAppStore.setState({ tab: 'combat' });
    } else if (data.planet && data.planet !== useLobbyStore.getState().state?.planet) {
      useAppStore.setState({ tab: 'lobby' });
    } else if (!data.gameId && useAppStore.getState().tab === 'combat') {
      useAppStore.setState({ tab: 'hub' });
    } else if (data.countdown) {
      useAppStore.setState({ tab: 'lobby' });
    }
    useLobbyStore.setState({ state: data });
  });

  Shared.MessageRegistry.emitter.on(Shared.LobbyInviteMessage.Opcode, (data) => {
    useLobbyStore.setState({ invitedState: data });
  });

  /* Chat */

  Shared.MessageRegistry.emitter.on(Shared.GlobalChatMessage.Opcode, (data) => {
    const tab = useAppStore.getState().tab;
    const activeChannelId = useChatStore.getState().activeChannelId;
    const blocked = useAppStore.getState().userData.blocked;

    if (blocked.includes(data.id)) return;

    if (tab !== 'chat' || data.channelId !== activeChannelId) {
      useChatStore.getState().removeUnreadChannel(data.channelId ?? '');
      useChatStore.getState().addUnreadChannel(data.channelId ?? '');
    }

    const message = {
      ...data,
      author: {
        role: data.role,
        id: data.authorId,
        avatar: data.avatar,
        username: data.username,
        premiumUntil: data.premiumUntil,
      },
      createdAt: new Date().toISOString(),
    };

    if (data.channelId) {
      useChatStore.getState().addMessages([message]);
    } else {
      useChatStore.getState().addLobbyMessage(message);
    }
  });
}
